var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
import { OpeningHours } from './opening-hours';
var PriceRule = /** @class */ (function (_super) {
    __extends(PriceRule, _super);
    function PriceRule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "PriceRule";
        _this.level = 1;
        return _this;
    }
    PriceRule.prototype.toProperty = function (name, value) {
        switch (name) {
            case "openings":
                value = Data.toData(OpeningHours, value);
                break;
            default:
                value = _super.prototype.toProperty.call(this, name, value);
                break;
        }
        return value;
    };
    PriceRule.isActive = function (rule, time, store) {
        if (!rule.openings) {
            return true;
        }
        var tmpStore = null;
        if (store && store.menu && store.menu.priceRules) {
            tmpStore = store.menu.priceRules;
        }
        return OpeningHours.isTimeOpen(tmpStore, rule.openings, time);
    };
    PriceRule.getUserScore = function (rule, member) {
        console.log("getUserScore2");
        var users = rule.users;
        if (!users || users.length == 0)
            return 0;
        //NOTE: Only support guest or member now
        var type = "guest";
        if (member) {
            type = "member";
        }
        if (users.indexOf(type) >= 0) {
            if (rule.tier) {
                if (rule.tier === member.tier)
                    return 100;
                return -10000;
            }
            else {
                return 100;
            }
        }
        else {
            return -10000;
        }
    };
    PriceRule.getModeScore = function (rule, mode) {
        var modes = rule.modes;
        console.log("getModeScore2", mode);
        if (!modes || modes.length == 0)
            return 0;
        if (rule.modes.indexOf(mode) >= 0) {
            return 100;
        }
        else {
            return -10000;
        }
    };
    PriceRule.getMatch = function (rule, time, mode, member, store) {
        var timeOk = PriceRule.isActive(rule, time, store);
        if (!timeOk) {
            console.log("not active");
            return -10000;
        }
        var userScore = PriceRule.getUserScore(rule, member);
        var modeScore = PriceRule.getModeScore(rule, mode);
        //var periodScore = PriceRule.getPeriodScore(rule);
        console.log("userScore", userScore, "modeScore", modeScore);
        return userScore + modeScore;
    };
    return PriceRule;
}(Data));
export { PriceRule };
//# sourceMappingURL=price-rule.js.map